import { useEffect, useState } from 'react';

interface IProductPriceProps {
    price: number,
    accessible?: boolean,
}

/**
 * Format price.
 */
const ProductPriceFormat = (props: IProductPriceProps) => {

    const [ accessible ] = useState(props.accessible === undefined ? true : props.accessible);
    const [ parts, setParts ] = useState<string[]>([]);
    const [ containsDot, setContainsDot ] = useState(false);
    const [ cents, seCents ] = useState('');
    const isNegative = (props.price || 0) < 0;

    useEffect(() => {
        if(props.price === undefined) return;

        const price = Math.abs(props.price);
        const parts = Math.abs(props.price).toString().trim().split('.');
        const containsDot = parts.length > 1;
        const cents = containsDot ? (parts[1].length === 1 ? (parts[1] + '0') : parts[1].substring(0, 2)) : '';

        // add thousands separator -------------------
        if(price >= 1000) {
            parts[0] = Math.floor(price).toLocaleString();
        }

        setParts(parts);
        setContainsDot(containsDot);
        seCents(cents);
    }, [ props.price ]);

    return (
        <span>
            {/* all */}
            <span aria-hidden="true">{ isNegative ? '-' : '' }${ containsDot ? <span>{parts[0]}<sup>{cents}</sup></span> : Math.abs(props.price).toLocaleString() }</span>

            {/* accessible */}
            { accessible && <span className="sr-only">Price { isNegative ? '-' : '' }${ Math.abs(props.price) }</span> }
        </span>
    );
};

export default ProductPriceFormat;